export const cmsInit = () => {
    if (typeof window.__bootWebpackJsonp !== 'undefined') {
        window.__bootWebpackJsonp();
    }
};
